import { lazyLoad } from 'utils/loadable';

import auth from '../auth';

import { useAuthSession } from './authSession';

const DefaultLayout = lazyLoad(
  () => import('../../layouts/default'),
  (module) => module.DefaultLayout
);
const RouteAuth = ({ access, children }: { access?: Array<string>; children: any }) => {
  const session = useAuthSession();
  if (!session.user) {
    auth.login();
    return <></>;
  }

  const isAuthorized = session.user.context?.userProfile.userType === 'taxpayer';
  if (isAuthorized) {
    return children;
  }
  return (
    <div>
      <DefaultLayout>
        <div> No Autorizado</div>
      </DefaultLayout>
    </div>
  );
};

export default RouteAuth;
